import React from 'react';

interface CompanyOverviewData {
  is_active?: boolean;
  profile_completeness_score?: number;
  enrichment_score?: number | null;
  domain?: string;
  last_enrichment_at?: string;
}

interface Props {
  company: CompanyOverviewData;
  scoringInProgress?: boolean;
}

export const CompanyOverviewTab: React.FC<Props> = ({ company, scoringInProgress = false }) => (
  <div>
    <h3 className="text-lg font-bold text-gray-900 mb-6">Company Overview</h3>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <p className="text-xs font-medium text-gray-500 mb-2">Status</p>
        <span className={`px-3 py-1 rounded-full text-xs font-medium ${company.is_active ? 'bg-green-50 text-green-700' : 'bg-gray-100 text-gray-700'}`}>
          {company.is_active ? 'Active' : 'Inactive'}
        </span>
      </div>
      <div>
        <p className="text-xs font-medium text-gray-500 mb-2">Profile Completeness</p>
        <div className="flex items-center gap-3">
          <div className="flex-1 bg-gray-200 rounded-full h-2">
            <div className="bg-blue-600 h-2 rounded-full transition-all" style={{ width: `${company.profile_completeness_score || 0}%` }} />
          </div>
          <span className="text-sm font-medium text-gray-900 flex items-center gap-1.5">
            {company.profile_completeness_score || 0}%
            {scoringInProgress && (
              <span className="inline-block w-3 h-3 border-2 border-t-transparent rounded-full animate-spin"
                style={{ borderColor: '#3B82F6', borderTopColor: 'transparent' }} />
            )}
          </span>
        </div>
      </div>
      <div>
        <p className="text-xs font-medium text-gray-500 mb-2">Enrichment Score</p>
        <div className="flex items-center gap-3">
          <div className="flex-1 bg-gray-200 rounded-full h-2">
            <div className="bg-purple-600 h-2 rounded-full transition-all" style={{ width: `${company.enrichment_score || 0}%` }} />
          </div>
          <span className="text-sm font-medium text-gray-900 flex items-center gap-1.5">
            {company.enrichment_score != null ? `${company.enrichment_score}%` : '—'}
            {scoringInProgress && (
              <span className="inline-block w-3 h-3 border-2 border-t-transparent rounded-full animate-spin"
                style={{ borderColor: '#9333EA', borderTopColor: 'transparent' }} />
            )}
          </span>
        </div>
      </div>
      {company.domain && (
        <div>
          <p className="text-xs font-medium text-gray-500 mb-2">Domain</p>
          <p className="text-sm text-gray-900">{company.domain}</p>
        </div>
      )}
      {company.last_enrichment_at && (
        <div>
          <p className="text-xs font-medium text-gray-500 mb-2">Last Enriched</p>
          <p className="text-sm text-gray-900">{new Date(company.last_enrichment_at).toLocaleDateString()}</p>
        </div>
      )}
    </div>
  </div>
);
